import React, { useEffect, useState } from "react";
import PatientHeader from "./components/PatientHeader";
import InfoSection from "./components/InfoSection";
import ConditionSection from "./components/ConditionSection";
import LastLoggedSection from "./components/LastLogged";
import { useLocation, useNavigate } from "react-router-dom";
import arrowLeft from "./../../assets/images/arrow-left.svg";
import { patientDetails } from "../referCarePlan/service";
import { Spin } from "antd";

const PatientDetails: React.FC = () => {
  const navigate = useNavigate();
  const [patientData, setPatientData] = useState<any>();
  const { state } = useLocation();
  const [loader, setLoader] = useState(false);

  const { patient_id }: any = state;

  useEffect(() => {
    getPatientDetails();
  }, []);

  const getPatientDetails = async () => {
    setLoader(true);
    const res: any = await patientDetails({
      getAllPlans: false,
      patientId: patient_id,
      source: "TatvaLite",
    });

    setLoader(false);
    if (res?.code === "1") {
      setPatientData(res?.data);
    }
  };

  const backBtnHandler = () => {
    navigate("/patients");
  };

  return (
    <>
      <div className="border-b border-[#EAECF0] p-6">
        <div className="flex items-start font-semibold gap-x-2">
          <img
            height={22}
            width={22}
            src={arrowLeft}
            alt="arrow-left"
            onClick={backBtnHandler}
          />
          <span>Patient Details</span>
        </div>
      </div>
      {loader && <Spin className="mt-4 flex justify-center" />}
      {state && !loader ? (
        <main className="flex flex-col w-full bg-[#F9F9FF] p-6">
          <PatientHeader name={state?.name} status={state?.referral_status} />
          {patientData?.patient_details && patientData?.patient_plans && (
            <>
              <InfoSection info={patientData?.patient_details} />
              <ConditionSection
                plan={{
                  ...patientData?.patient_plans,
                  ...patientData?.patient_details,
                  status: patientData?.patient_plans?.status,
                }}
              />
            </>
          )}
          <LastLoggedSection
            patientData={{
              ...(patientData?.patient_details || {}),
              status:
                patientData?.patient_plans?.status || state?.referral_status,
              therapyArea: state?.therapyArea,
              medical_condition_name: state?.medical_condition_name,
              patient_id: state?.patient_id,
              name: state?.name,
              mobile: state?.contact_no || state?.mobile,
            }}
          />
        </main>
      ) : (
        <div className="flex justify-center items-center h-[50vh] text-gray-800 font-poppins font-medium">
          No patient details found!
        </div>
      )}
    </>
  );
};

export default PatientDetails;
